
import React from 'react';
import { Button } from '@/components/ui/button';
import { QuickActionData } from '@/types/crm';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';

export const QuickActionButton: React.FC<QuickActionData> = ({ title, description, icon: Icon, iconColor, bgColor, href }) => {
  return (
    <Button variant="outline" className="h-auto p-4 flex flex-col items-start text-left justify-start hover:shadow-md transition-shadow" asChild>
      <Link to={href}>
        <div className={cn("p-2 rounded-md mb-3", bgColor)}>
          <Icon className={cn("h-5 w-5", iconColor)} />
        </div>
        <p className="font-semibold text-sm mb-1">{title}</p>
        <p className="text-xs text-muted-foreground">{description}</p>
      </Link>
    </Button>
  );
};

